/**
 * Public Route Component (Auth Pages Only)
 *
 * Redirects authenticated users away from login/register.
 * Honors return URL from ProtectedRoute when present.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppSelector';
import {
  buildReturnPathFromString,
  resolvePostLoginRedirect,
} from '../../utils/authReturnUrl';

interface PublicRouteProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const location = useLocation();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (isAuthenticated) {
    const storedAuthRedirect = localStorage.getItem('auth_redirect');
    const destination = resolvePostLoginRedirect({
      locationState: location.state,
      storedAuthRedirect,
      userRoles: user?.roles,
      currentPathname: location.pathname,
    });

    if (destination) {
      if (
        storedAuthRedirect &&
        destination === buildReturnPathFromString(storedAuthRedirect)
      ) {
        localStorage.removeItem('auth_action');
        localStorage.removeItem('auth_redirect');
      }
      return <Navigate to={destination} replace />;
    }

    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
